import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import {
    DynamicDialogConfig,
    DynamicDialogRef,
    Message,
    SelectItem
} from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-setup-update-dialog',
    templateUrl: './invoice-setup-update-dialog.component.html',
    styleUrls: ['./invoice-setup-update-dialog.component.scss'],
    standalone: false
})
export class InvoiceSetupUpdateDialogComponent implements OnInit {
    addresses: SelectItem[];
    disclaimerProperties: SelectItem[];
    signatureLineProperties: SelectItem[];
    accountClassProperties: SelectItem[];
    LevelspentSelectItems: SelectItem[];
    invoiceViewOptions: SelectItem[];
    count: number;
    bulkFormGroup: UntypedFormGroup;
    moment: any;
    messages: Message[];

    // Track indeterminate states for each checkbox
    checkboxStates: { [key: string]: { value: boolean | null; indeterminate: boolean } } = {};
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService
    ) {
        this.bulkFormGroup = new UntypedFormGroup({
            ShowEIN: new UntypedFormControl(),
            Showindirectrates: new UntypedFormControl(),
            Showlaborrates: new UntypedFormControl(),
            Remitaddrid: new UntypedFormControl(),
            Billaddrid: new UntypedFormControl(),
            Accountclass: new UntypedFormControl(),
            Siglineid: new UntypedFormControl(),
            Invprefix: new UntypedFormControl(),
            Levelspent: new UntypedFormControl(),
            Showfundingbalance: new UntypedFormControl(),
            Showcontractbalance: new UntypedFormControl(),
            Showcosttypesummary: new UntypedFormControl(),
            Showcosttypesummaryburden: new UntypedFormControl(),
            Showburdens: new UntypedFormControl(),
            Showcurrentactivityonly: new UntypedFormControl(),
            Invoiceviewoptionid: new UntypedFormControl(),
            Disclaimerid: new UntypedFormControl()
        });

        // Initialize checkbox states as indeterminate
        const checkboxFields = [
            'ShowEIN', 'Showindirectrates', 'Showlaborrates', 'Showfundingbalance',
            'Showcontractbalance', 'Showcosttypesummary', 'Showcosttypesummaryburden',
            'Showburdens', 'Showcurrentactivityonly'
        ];

        checkboxFields.forEach(field => {
            this.checkboxStates[field] = { value: null, indeterminate: true };
        });

        this.addresses = config.data.addresses;
        this.disclaimerProperties = config.data.disclaimerProperties;
        this.signatureLineProperties = config.data.signatureLineProperties;
        this.accountClassProperties = config.data.accountClassProperties;
        this.LevelspentSelectItems = config.data.LevelspentSelectItems;
        this.invoiceViewOptions = config.data.invoiceViewOptions;
        this.count = config.data.count;
        this.moment = moment;
        this.messages = [
            {
                severity: 'info',
                summary: '',
                style: 'max-width: fit-content',
                detail: 'Fill in options below to update all selected rows. Options not updated here will remain unchanged. For checkboxes, "-" indicates no change.'
            } as any
        ];
    }

    ngOnInit(): void {}

    // Handle checkbox state changes
    onCheckboxChange(fieldName: string, event: any): void {
        const state = this.checkboxStates[fieldName];

        if (state.indeterminate) {
            // First click from indeterminate: set to true
            state.value = true;
            state.indeterminate = false;
            this.bulkFormGroup.get(fieldName)?.setValue(true);
        } else if (state.value === true) {
            // Second click: set to false
            state.value = false;
            this.bulkFormGroup.get(fieldName)?.setValue(false);
        } else {
            // Third click: back to indeterminate
            state.value = null;
            state.indeterminate = true;
            this.bulkFormGroup.get(fieldName)?.setValue(null);
        }
    }

    // Method to reset a specific checkbox to indeterminate
    resetToIndeterminate(fieldName: string): void {
        this.checkboxStates[fieldName] = { value: null, indeterminate: true };
        this.bulkFormGroup.get(fieldName)?.setValue(null);
    }

    // Method to reset all checkboxes to indeterminate
    resetAllToIndeterminate(): void {
        Object.keys(this.checkboxStates).forEach(field => {
            this.resetToIndeterminate(field);
        });
    }
}
